import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ShowFieldHistoryPage } from './show-field-history.page';

const routes: Routes = [
  {
    path: '',
    component: ShowFieldHistoryPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShowFieldHistoryPageRoutingModule {}
